import { AbstractControl, ValidationErrors } from '@angular/forms';
import { SchemaPathTree, validate } from '@angular/forms/signals';

export function normalizeString(textToNormalize: string): string {
  return textToNormalize
    ? textToNormalize
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s/g, '')
        .replace(/[^\w\s]/gi, '')
        .toLowerCase()
    : '';
}

export const PATTERN_TEXT = /^[\u0000-\u00FF]*$/;

export function noOnlyWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  if (typeof control.value === 'string' && control.value.trim().length === 0) {
    return { whitespace: true };
  }
  return null;
}

// !!!! version of noOnlyWhitespaceValidator that works with Angular signal forms, delete noOnlyWhitespaceValidator when all forms are migrated to signals
export function validateNoOnlyWhitespace(path: SchemaPathTree<string>): void {
  validate(path, ({ value }) => {
    if (typeof value() === 'string' && value().length > 0 && value().trim().length === 0) {
      return { kind: 'whitespace', message: 'COMMON.NO_ONLY_WHITESPACE' };
    }
    return null;
  });
}
